export enum CHART_LAYOUT_TYPE {
  VERTICAL,
  HORIZONTAL,
  GRID,
}

export enum AXIS_TYPE {
  X = 'x',
  Y = 'y',
  XY = 'xy',
}
